import { Box, Card, CardContent, Chip, Grid, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

import type { ThingToDo } from '@/src/types/destinationResult'

interface ThingsToDoProps {
    things: ThingToDo[]
}

const CATEGORY_COLORS: Record<ThingToDo['category'], string> = {
    culture: 'primary',
    food: 'warning',
    shopping: 'secondary',
    nightlife: 'error',
    outdoor: 'success',
    family: 'info',
} as const

const ThingsToDo: React.FC<ThingsToDoProps> = ({ things }) => {
    const t = useTranslations('destinationPage')
    return (
        <Box component="section" sx={{ mb: 4 }}>
            <Typography
                component="h2"
                variant="h6"
                sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.1rem' }, mb: 2 }}
            >
                {t('thingsToDo')}
            </Typography>
            <Grid container spacing={{ xs: 1, sm: 2 }} component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                {things.map((item, i) => (
                    <Grid key={`${item.title}-${i}`} size={{ sm: 12, md: 6 }} component="li">
                        <Card variant="outlined" sx={{ borderRadius: 2, height: '100%' }}>
                            <CardContent sx={{ p: { xs: 1.25, sm: 2 }, '&:last-child': { pb: { xs: 1.25, sm: 2 } } }}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 0.75, flexWrap: 'wrap', gap: 0.5 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.3, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                                        {item.title}
                                    </Typography>
                                    <Chip
                                        label={item.category}
                                        size="small"
                                        color={CATEGORY_COLORS[item.category] as any}
                                        variant="outlined"
                                        sx={{ fontSize: '0.6rem', height: 18, flexShrink: 0 }}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, fontSize: { xs: '0.7rem', sm: '0.8125rem' } }}>
                                    {item.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default ThingsToDo
export type { ThingsToDoProps }
